import View from './view';

import { promisify } from '../utils/promisify'; 

export default View.extend( {
    template: 'jst/suggestion',
    
    className: 'suggestion-nest',

    initialize(options = {}) {
        View.prototype.initialize.call( this, options );
    },

    events: {

        'click .suggestion-item': function(e) {
            this.choose( this.$( e.currentTarget ) );
            return e.stopPropagation(), e.preventDefault(), false;
        },

        // prevent blur in the input
        'mousedown .suggestion-item': function(e) {
            return e.stopPropagation(), e.preventDefault(), false;
        },

        // prevent blur in the input
        'mousedown .__page-down': function(e) {
            return false;
        },

        // prevent blur in the input
        'mousedown .__page-up': function(e) {
            return false;
        },

        'mousemove .suggestion-item': function(e) {
            this.hover( this.$( e.currentTarget ) );
        },

        'click .__page-up': function(e) {
            this.pageUp();
        },

        'click .__page-down': function(e) {
            this.pageDown();
        },
        
    },

    open() {
        this.page_ = 0;
        this.firstPage_ = this.lastPage_ = false;
        this.currentIndex_ = 0;
        this.$el.html( '' );
        this.render();
    },

    suggest() {
        this.currentIndex_ = 0;
        this.render();
    },

    pageDown() {
        if (!this.lastPage_) {
            this.page_++;
            this.render();
        }
    },

    pageUp() {
        if (!this.firstPage_) {
            this.page_--;
            this.render();
        }
    },

    choose($item) {
        const index = +$item[0].dataset.index,
            option = this.lastContext.items[index];

        this.trigger( 'choose', $item.find( '.suggestion-item--text' ).html(), option );
    },

    hover($item) {
        const oldIndex = this.currentIndex_;
        this.currentIndex_ = +$item[0].dataset.index;

        if (this.currentIndex_ != oldIndex)
            updateItems( this );
    },

    chooseCurrent() {
        this.choose( this.$currentItem() );
    },

    nextItem() {
        if (this.currentIndex_ + 1 <= this.itemCount() - 1) {
            this.currentIndex_++;
            return updateItems( this );
        }

        if (!this.lastPage_) {
            this.currentIndex_ = 0;
            this.pageDown();
        }
    },

    prevItem() {
        if (this.currentIndex_ - 1 >= 0) {
            this.currentIndex_--;
            return updateItems( this );
        }

        if (!this.firstPage_) {
            this.currentIndex_ = 9;
            this.pageUp();
        }
    },

    serialize() {
        return promisify( this.options.optionsFn( this.page_ ) )
            .then( ({ options, total, page, offset, limit }) => {
                const first = offset > 0 ? offset + 1 : page * 10 + 1,
                    last = Math.min( total, first + (limit || 10) - 1 ),
                    showInfo = undefined === this.options.showInfo 
                        ? total > 9 
                        : this.options.showInfo;

                this.firstPage_ = page === 0;
                this.lastPage_ = last === total;

                return { 
                    items: options,
                    currentIndex: this.currentIndex_, 
                    total, first, last, showInfo,
                    firstPage: this.firstPage_,
                    lastPage: this.lastPage_,
                };
            } );
    },

    afterRender() {
        this.trigger( 'hover', this.currentItem(),
            this.lastContext.items, 
            this.currentIndex_ );
    },

    $items() {
        return this.$( 'li' );
    },

    itemCount() {
        return this.$items().length;
    },

    currentItem() {
        return this.lastContext.items[this.currentIndex_];
    },

    $currentItem() {
        return this.$items().eq( this.currentIndex_ );
    }

} );

function updateItems(instance) {
    instance.$items()
        .removeClass( '--active' )
        .eq( instance.currentIndex_ )
        .addClass( '--active' );

    instance.trigger( 'hover', instance.currentItem(),
        instance.lastContext.items, 
        instance.currentIndex_ );
}


// WEBPACK FOOTER //
// ./src/js/view/suggestion.js